export default "__VITE_ASSET__BpnUtoEY__"